import { FilterDataRequestDTO, SortDataRequestDTO, DataRequestDTO, FilterItemDataRequestDTO } from "../dto/data-request.dto";

export class HelperDataRequest {
    private static readonly _maxResultCount = "maxResultCount";
    private static readonly _skipCount = "skipCount";
    private static readonly _filter = "filter";
    private static readonly _sorting = "sorting";
    // pageIndex start from 1
    public static convertDataRequest(pageSize: number, pageIndex: number, filter?: FilterDataRequestDTO, sorting?: Array<SortDataRequestDTO>, searchText?: string): DataRequestDTO {
        let maxResultCount: number = pageSize;
        let skipCount: number = (pageIndex - 1) * pageSize;
        let result: DataRequestDTO = {
            skipCount: skipCount,
            offset: skipCount,
            maxResultCount: maxResultCount,
            searchText: searchText
        }
        if (this.hasValue(filter) && filter?.filters && filter?.filters?.length > 0) {
            result.filter = this.convertFilterToString(filter!)
        }
        if (this.hasValue(sorting)) {
            result.sorting = this.convertSortToString(sorting!)

        }
        return result;
    }
    static convertFilterToString(filter: FilterDataRequestDTO) {
        let str = '';
        str = filter.filters.map((f: FilterDataRequestDTO | FilterItemDataRequestDTO) => {

            if (!this.hasListValue((f as FilterDataRequestDTO).filters)) {

                return this.p_convertFilterItemToString(f as FilterItemDataRequestDTO);
            }
            return `(${this.convertFilterToString(f as FilterDataRequestDTO)})`;
        }).join(`~${filter.logic}~`)
        return str;
    }
    private static p_convertFilterItemToString(filter: FilterItemDataRequestDTO) {
        let str = '';
        const value = filter.value;
        if (typeof value === 'string') {
            str = `${filter.field}~${filter.operator}~'${value}'`
        }
        else {
            //field~gte~10
            str = `${filter.field}~${filter.operator}~${value}`
        }
        return str;
    }
    static convertSortToString(sorts: Array<SortDataRequestDTO>) {
        return sorts.map(
            s => {
                return `${s.field}-${s.dir}`
            }
        ).join('~')
    }
    static hasValue(value: any): boolean {
        return !(value === undefined || value === null);
    }
    static hasListValue(value: any): boolean {
        return !(value === undefined || value === null || value.length == 0);
    }
}

